import axios from "../../config/axiosConfig";
import { CREATE_BOOK, GET_BOOK, BOOK_REQUEST, DELETE_BOOK, UPDATE_BOOK, BOOK_REQUEST_FAILURE, UPDATE_BOOK_IN_MASTER_OPTIONS, ADD_BOOK_IN_MASTER_OPTIONS,
  DELETE_BOOK_IN_MASTER_OPTIONS, UPDATE_BOOK_IN_LIST, ADD_BOOK_IN_LIST, DELETE_BOOK_IN_LIST
 } from "../types";
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getBooks = (commonMaster) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BOOK_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/book/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BOOK, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBook = (book) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: BOOK_REQUEST });
      return axios.post("/book/add", book,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          if (response.data) {
            dispatch({ type: CREATE_BOOK, payload: response.data });
            dispatch(addMasterInOption('books', response.data));
          } else {
            dispatch({
              type: BOOK_REQUEST_FAILURE,
              error: "Book create failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });   
          throw error; 
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateBook = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BOOK_REQUEST });
      const { auth } = getState();
      return axios.put("/book/update", { id, data }, {
        params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id  }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_BOOK,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('books', id, response.data));
        } else {
          dispatch({
            type: BOOK_REQUEST_FAILURE,
            error: "Book update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteBook = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: BOOK_REQUEST });
      return axios.delete(`/book/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_BOOK, id: id });
          dispatch(updateMasterInOption('books', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BOOK_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateStateOnUpdateBookById = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id };
      return axios.get(`/book/get/${id}`, { params }).then((response) => {
        dispatch({ type: UPDATE_BOOK_IN_LIST, payload: { id, data: response.data } });
        dispatch({ type: UPDATE_BOOK_IN_MASTER_OPTIONS, payload: { id, data: response.data } });
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateStateOnAddBookById = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id };
      return axios.get(`/book/get/${id}`, { params }).then((response) => {
        dispatch({ type: ADD_BOOK_IN_LIST, payload: { data: response.data } });
        dispatch({ type: ADD_BOOK_IN_MASTER_OPTIONS, payload: { data: response.data } });
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateStateOnDeleteBookById = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      
      dispatch({ type: DELETE_BOOK_IN_LIST, payload: { id } });
      dispatch({ type: DELETE_BOOK_IN_MASTER_OPTIONS, payload: { id } });

    } catch (error) {
      console.error(error);
    }
  };
};